{
  "defaultTitle": "Impossible de s'enregistrer",
  "defaultMessage": "Veuillez confirmer les informations avec votre répartiteur ou contacter l'entrepôt",
  "backToHomescreen": "Retour à l'écran d'accueil",
  "hideErrorLog": "MASQUER LE JOURNAL DES ERREURS",
  "viewErrorLog": "VOIR LE JOURNAL DES ERREURS",
  "errorLogMessageLabel": "Message :",
  "errorLogStatusLabel": "Code d'état :",
  "unknown": "Inconnu"
}
